"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var endpoints_1 = require("./endpoints");
var Util_1 = require("./Util");
var Util_2 = require("./Util");
// Uses the fetch API to obtain the next calibration barcode.
// responseToken: A calibration token returned in the response to a request to calibrate the data in the previous calibration token.
// smallBarcode: A boolean value indicating whether 
function fetchNextCalibrationBarcode(responseToken, germanPackTest, smallBarcode) {
    var json = JSON.stringify(responseToken);
    var url = endpoints_1.default.Calibration.Api.FetchNextCalibrationBarcode + (germanPackTest ? "?" + Util_2.getQuery({ "germanPackTest": germanPackTest }) + (smallBarcode ? "&" + Util_2.getQuery({ "smallBarcode": smallBarcode }) : "") : smallBarcode ? "?" + Util_2.getQuery({ "smallBarcode": smallBarcode }) : "");
    return Util_1.getJson2(url, {
        method: "post",
        body: json
    });
}
exports.fetchNextCalibrationBarcode = fetchNextCalibrationBarcode;
// Uses the fetch API to calibrate input obtained by scanning a calibration barcode.
// responseToken: A calibration token returned in the response to a request for the next calibration token.
// dom3KeyboardEventCodeSupport: A boolean value indicating if the browser supports DOM 3 keyboardEvent code properties.
function fetchCalibrate(responseToken, germanPackTest, dom3KeyboardEventCodeSupport) {
    var json = JSON.stringify(responseToken);
    return Util_1.getJson2((dom3KeyboardEventCodeSupport
        ? endpoints_1.default.Calibration.Api.FetchCalibrateForDom3KeyboardEventCodes
        : endpoints_1.default.Calibration.Api.FetchCalibrate) +
        (germanPackTest ? "?" + Util_2.getQuery({ "germanPackTest": germanPackTest }) : ""), {
        method: "post",
        body: json
    });
}
exports.fetchCalibrate = fetchCalibrate;
//# sourceMappingURL=CalibrationFunctions.js.map